<template>
    <div class="nevs-content">
        <div class="nevs-content-top-buttons">
            <NevsButton class="primary" @click="addGroup">
                <i class="fa-solid fa-plus"></i>
                {{ $LANG.Get('buttons.addGroup') }}
            </NevsButton>
        </div>
        <NevsCard>
            <NevsTable
                :default-sort="tableData.defaultSort"
                :fields="tableData.fields"
                :height="tableData.height"
                :total-records="tableData.totalRecords"
                @reload="reloadGroups">
                <tr class="nevs-table-filters">
                    <td>
                        <NevsTextField v-model="tableData.filters.name"></NevsTextField>
                    </td>
                    <td></td>
                    <td></td>
                </tr>
                <tr v-for="(group, key) in tableData.records" :key="key">
                    <td class="nevs-table-linked-cell" @click="editGroup(group)">{{ group.name }}</td>
                    <td class="nevs-table-linked-cell" @click="editGroup(group)">{{ group.persons_count }}</td>
                    <td class="nevs-table-actions">
                        <span :title="$LANG.Get('tooltips.edit')" class="nevs-table-button" @click="editGroup(group)"><i
                            class="fa-solid fa-pen"></i></span>
                        <span :title="$LANG.Get('tooltips.delete')" class="nevs-table-button" @click="deleteGroup(group)"><i
                            class="fa-solid fa-trash"></i></span>
                    </td>
                </tr>
            </NevsTable>
        </NevsCard>
    </div>
</template>

<script>

import NevsCard from "@/components/nevs/NevsCard.vue";
import NevsButton from "@/components/nevs/NevsButton.vue";
import NevsTextField from "@/components/nevs/NevsTextField.vue";
import NevsTable from "@/components/nevs/NevsTable.vue";

export default {
    name: "ModuleGroups",
    components: {NevsTable, NevsTextField, NevsButton, NevsCard},
    data() {
        return {
            tableData: {
                fields: [
                    {
                        name: 'name',
                        label: this.$LANG.Get('fields.name')
                    },
                    {
                        name: 'persons_count',
                        label: this.$LANG.Get('fields.persons')
                    },
                    {
                        name: 'actions',
                        width: '80px',
                        label: '',
                        sortable: false
                    }
                ],
                filters: {
                    name: ''
                },
                records: [],
                lastRequest: null,
                totalRecords: 0,
                defaultSort: {
                    field: 'name',
                    descending: false
                },
                filterTimer: null,
                height: '0px'
            }
        }
    },
    watch: {
        'tableData.filters': {
            handler() {
                if (this.tableData.filterTimer !== null) {
                    clearTimeout(this.tableData.filterTimer);
                }
                let vm = this;
                this.tableData.filterTimer = setTimeout(function () {
                    vm.reloadGroups(vm.tableData.lastRequest);
                }, 500);
            },
            deep: true
        }
    },
    methods: {
        editGroup(group) {
            this.$router.push('/groups/' + group.id);
        },
        addGroup() {
            this.$router.push('/groups/0');
        },
        deleteGroup(group) {
            let vm = this;
            this.$LOCAL_BUS.TriggerEvent('popup', {
                type: 'confirm', text: this.$LANG.Get('alerts.generalRemovalQuestion'), callback: (response) => {
                    if (response) {
                        this.$API.APICall('delete', 'groups/' + group.id, {}, (data, success) => {
                            if (success) {
                                vm.reloadGroups(vm.tableData.lastRequest);
                            } else {
                                vm.$HELPERS.HandleServerError(vm, data);
                            }
                        });
                    }
                }
            });
        },
        reloadGroups(request) {
            let vm = this;
            request.filters = this.tableData.filters;
            this.tableData.lastRequest = JSON.parse(JSON.stringify(request));
            this.$API.APICall('get', 'groups', request, (data, success) => {
                if (success) {
                    vm.tableData.records = data.records;
                    vm.tableData.totalRecords = data.total_records;
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        },
        resolveWindowResize() {
            this.tableData.height = window.innerHeight - 205 + 'px';
        }
    },
    mounted() {
        this.$store.commit('selectMenu', 'clients');
        this.$store.commit('selectSubMenu', 'groups');
        this.$store.commit('setBreadcrumbs', [
            {
                label: this.$LANG.Get('modules.clients'),
                link: null
            },
            {
                label: this.$LANG.Get('modules.groups'),
                link: null
            }
        ]);
        window.addEventListener('resize', this.resolveWindowResize);
        this.resolveWindowResize();
    },
    unmounted() {
        window.removeEventListener('resize', this.resolveWindowResize);
    }
}
</script>
